import { Button, Popover, Typography } from "@blofin/blofin-ui";
import { useTranslations } from "use-intl";
import Logo from "../assets/header/logo.svg?react";
import { FC, Fragment, useMemo } from "react";
import X from "../assets/footer/social/x.svg?react";
import Email from "../assets/footer/social/email.svg?react";
import Telegram from "../assets/footer/social/telegram.svg?react";
import Instagram from "../assets/footer/social/instagram.svg?react";
import DownloadDark from "../assets/footer/social/download-dark.svg?react";
// import DownloadLight from "../assets/footer/social/download-light.svg?react";
import {
  IconStyle,
  LabelColor,
  PopoverBgStyles,
  PopoverHoverStyle,
  TextColor,
  TitleColor,
  WrapperStyles,
  footerBg,
  simpleFooterBg,
  simpleTextColor,
  simpleTextLine,
  footerContainerStyle,
  LogoStyle,
  infoColor
} from "./styles";
import Hot from "../Header/Hot";
import { useStoreState } from "./store/useStore";
import useColor from "../Header/hooks/useColor";

export const ZENDESK_LANG: Record<string, string> = {
  en: "en-us",
  es: "es-001",
  fr: "fr",
  ru: "ru",
  "uk-ua": "uk",
  vi: "vi"
};

const reflectLang: any = {
  "zh-tw": "-tw",
  "ko-kr": "-kr"
};

const Footer: FC<{ footerBgColor?: string; isSimple?: boolean; size?: "1280" | "1440" }> = ({
  footerBgColor,
  isSimple,
  size = "1280"
}) => {
  const t = useTranslations("footer");

  const { theme, localeLink, locale, baseUrl, isLogin, env } = useStoreState();

  const { isUk } = useColor(baseUrl, env);

  const FOOTER_MAIN = [
    {
      label: "about",
      menus: [
        // { title: "aboutUs", link: "/about-us", outbound: false },
        {
          title: "terms",
          link: "https://blockfin.zendesk.com/hc/en-us/articles/12335429133071-TERMS-OF-USE",
          outbound: true
        },
        { title: "privacy", link: "/privacy", outbound: true },
        { title: "riskWarning", link: "/risk-warning", outbound: true },
        {
          title: "announcements",
          link: "https://blockfin.zendesk.com/hc/en-us/categories/12339455434383-Announcement-Center",
          outbound: true
        }
        // { title: "bbbbbbApp", link: `/download`, outbound: false }
      ]
    },
    {
      label: "products",
      menus: [
        // { title: "buyCrypto", link: "/crypto?", outbound: false },
        { title: "trade", link: `/futures${localeLink}/BTC-USDT`, outbound: true },
        { title: "spotTrading", link: `/spot${localeLink}/BTC-USDT`, outbound: true },
        { title: "tradingBots", link: `/futures${localeLink}/BTC-USDT?mode=tools`, outbound: true },
        { title: "copyTrading", link: `/copy-trade`, outbound: false },
        // { title: "earn", link: `/earn`, outbound: false },
        { title: "welcomeBonus", link: "/task-center", outbound: false },
        { title: "activityCenter", link: `/activity/`, outbound: false }
        // { title: "academy", link: `/academy`, outbound: false },
        // { title: "news", link: `/news`, outbound: false }
      ]
    },
    {
      label: "trade",
      menus: [
        { title: "btc-usdt", link: `/futures${localeLink}/BTC-USDT`, outbound: true },
        { title: "eth-usdt", link: `/futures${localeLink}/ETH-USDT`, outbound: true },
        { title: "doge-usdt", link: `/futures${localeLink}/DOGE-USDT`, outbound: true },
        { title: "sol-usdt", link: `/futures${localeLink}/SOL-USDT`, outbound: true },
        { title: "xrp-usdt", link: `/futures${localeLink}/XRP-USDT`, outbound: true }
        // { title: "cryptoPrice", link: "/price/", outbound: false },
        // { title: "bitcoinPrice", link: `/price/coins/bitcoin`, outbound: false },
        // { title: "ethereumPrice", link: "/price/coins/ethereum", outbound: false },
        // { title: "solanaPrice", link: "/price/coins/solana", outbound: false },
        // { title: "xrpPrice", link: "/price/coins/ripple", outbound: false }
      ]
    }
  ];

  const FOOTER_MENU = useMemo(() => {
    const serviceMenus = [
      { title: "affiliates", link: "/affiliates", outbound: false },
      ...(isUk ? [] : [{ title: "referral", link: "/referral", outbound: false }]),
      // { title: 'ambassador', link: '/ambassador', outbound: false },
      { title: "data", link: "/data/information/BTC-USDT", outbound: false, hot: false }
      // { title: "proofOfReserves", link: "/proof-of-reserves", outbound: false },
    ];

    return [
      {
        label: "support",
        menus: [
          { title: "helpCenter", link: "https://blockfin.zendesk.com/hc/", outbound: true },
          // {
          //   title: 'submitRequest',
          //   link: 'https://blofin.zendesk.com/hc/requests/new',
          //   outbound: true
          // },
          { title: "apis", link: "/account/apis", outbound: false },
          { title: "fees", link: "/fees", outbound: false },
          { title: "officialVerification", link: "/official-verification", outbound: false }
        ]
      },
      {
        label: "service",
        menus: serviceMenus
      }
    ];
  }, [isUk]);

  const simpleUrl = [
    {
      title: "data",
      link: "/data/information/BTC-USDT",
      outbound: false
    },
    { title: "fees", link: "/fees", outbound: false },
    // { title: "apis", link: "/apis", outbound: false, hot: false },
    {
      title: "helpCenter",
      link: `https://blockfin.zendesk.com/hc/${ZENDESK_LANG[locale || "en"] || ZENDESK_LANG["en"]}`,
      outbound: true
    }
  ];

  if (isSimple) {
    return (
      <footer className={`${simpleFooterBg({ theme })} ${footerBgColor}`}>
        <div className="w-full max-w-screen-xl px-0 flex items-center">
          {simpleUrl.map((item, index) => (
            <div key={item.title} className="flex items-center justify-start">
              {item.outbound ? (
                <li className="leading-5">
                  <p className={`${simpleTextColor({ theme })}`}>
                    <a
                      href={`${item.link}`}
                      className="flex items-center hover:text-base-primary"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t(item.title)}
                    </a>
                  </p>
                </li>
              ) : (
                <li className="leading-5">
                  <p className={`${simpleTextColor({ theme })}`}>
                    <a
                      href={`${localeLink}${item.link}`}
                      className="flex items-center hover:text-base-primary"
                    >
                      {t(item.title)}
                    </a>
                  </p>
                </li>
              )}
              {index !== simpleUrl.length - 1 && (
                <div className={`${simpleTextLine({ theme })}`}></div>
              )}
            </div>
          ))}
          <div
            className={`ml-[48px] text-sm leading-[18px] ${theme === "light" ? "text-light-label-40" : "text-dark-label-40"}`}
          >
            {t("bbbbbbRights", { year: new Date().getFullYear() })}
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={`${footerBg({ theme })} ${footerBgColor}`}>
      <div className={`${footerContainerStyle({ theme, size })} px-0 md:px-[40px] mx-auto`}>
        <div className="mb-[40px] max-[600px]:mb-[16px] w-full">
          <Typography variant="body4" className={TitleColor({ theme })}>
            <Logo
              className={`w-[144px] h-[38px] ${LogoStyle({
                theme
              })}`}
            />
          </Typography>
          <p
            className={`mt-[16px] text-[12px] ${infoColor({
              theme
            })}`}
          >
            © 2023-2025 BLOCKFIN.COM
          </p>
        </div>
        <div className="flex flex-wrap items-start justify-between w-full gap-4 md:gap-0">
          <div className={WrapperStyles({ theme })}>
            <div className="flex flex-wrap">
              {FOOTER_MAIN.map((row) => (
                <div key={row.label} className="md:basis-1/5 mb-2 md:mb-0">
                  <Typography
                    variant="subtitle2"
                    weight="medium"
                    className={`mb-[20px] ${TitleColor({ theme })}`}
                  >
                    {t(row.label)}
                  </Typography>
                  <ul className="flex flex-col gap-3">
                    {row.menus.map((menu) => (
                      <Fragment key={menu.title}>
                        {menu.outbound ? (
                          <li className="leading-5">
                            <p className="text-base font-normal">
                              <a
                                href={`${menu.link}`}
                                className="flex items-center hover:text-base-primary"
                                target="_blank"
                                rel="noreferrer"
                              >
                                {t(menu.title)}
                              </a>
                            </p>
                          </li>
                        ) : (
                          <li className="leading-5">
                            <p className="text-base font-normal">
                              <a
                                href={`${localeLink}${menu.link}`}
                                className="flex items-center hover:text-base-primary"
                              >
                                {t(menu.title)}
                              </a>
                            </p>
                          </li>
                        )}
                      </Fragment>
                    ))}
                  </ul>
                </div>
              ))}
              <div className="md:basis-1/5 mb-2 md:mb-0">
                {FOOTER_MENU.map((row) => (
                  <div key={row.label} className="mb-[40px]">
                    <Typography
                      variant="subtitle2"
                      weight="medium"
                      className={`mb-[20px] ${TitleColor({ theme })}`}
                    >
                      {t(row.label)}
                    </Typography>
                    <ul className="flex flex-col gap-3">
                      {row.menus.map((menu) => (
                        <Fragment key={menu.title}>
                          {menu.outbound ? (
                            <li className="leading-5">
                              <p className="text-base font-normal">
                                <a
                                  href={`${menu.link}`}
                                  className="flex items-center hover:text-base-primary"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {t(menu.title)}
                                  {menu.hot && <Hot theme={theme} text="BETA" />}
                                </a>
                              </p>
                            </li>
                          ) : (
                            <li className="leading-5">
                              <p className="text-base font-normal">
                                <a
                                  href={`${localeLink}${menu.link}`}
                                  className="flex items-center hover:text-base-primary"
                                >
                                  {t(menu.title)} {menu.hot && <Hot theme={theme} text="BETA" />}
                                </a>
                              </p>
                            </li>
                          )}
                        </Fragment>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <div className="md:basis-1/5 mb-2 md:mb-0">
                <Typography
                  variant="subtitle2"
                  weight="medium"
                  className={`mb-[24px] ${TitleColor({ theme })}`}
                >
                  {t("tradeAnywhereWithbbbbbb")}
                </Typography>
                <Button
                  className="w-full mb-[32px]"
                  variant="tertiary"
                  size="large"
                  onClick={() => {
                    if (!isLogin) {
                      let referral_code = "";
                      if ("URLSearchParams" in window) {
                        referral_code =
                          new URLSearchParams(window.location.search).get("referral_code") || "";
                      }
                      window.location.href = `${localeLink}/register${referral_code ? `?referral_code=${referral_code}` : ""}`;
                    } else {
                      window.location.href = `/futures${localeLink}/BTC-USDT`;
                    }
                  }}
                >
                  {isLogin ? t("trade") : t("register")}
                </Button>
                <div>
                  {/* {theme === "light" ? (
                    <DownloadLight className="w-[120px] h-[120px] mb-[12px]"></DownloadLight>
                  ) : (
                    <DownloadDark className="w-[120px] h-[120px] mb-[12px]"></DownloadDark>
                  )} */}
                  <DownloadDark className="w-[120px] h-[120px] mb-[12px]"></DownloadDark>
                </div>
                <span className={`${TextColor({ theme })} ml-[6px]`}>{t("download")}</span>
              </div>
            </div>
          </div>
          <div className="w-full max-w-screen-xl px-0">
            <div className="flex gap-[16px] mt-[40px] max-[600px]:mt-0">
              <a href="https://x.com/BlockFin_Global" target="_blank" rel="noreferrer">
                <X className={IconStyle({ theme })} />
              </a>
              <a href=" https://t.me/BlockFinOfficial" target="_blank" rel="noreferrer">
                <Telegram className={IconStyle({ theme })} />
              </a>
              <a
                href="https://www.instagram.com/blockfin_official"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className={IconStyle({ theme })} />
              </a>
              <Popover
                placement="top"
                x={80}
                label={<Email className={IconStyle({ theme })} />}
                content={
                  <div
                    className={`py-[16px] w-[220px] flex flex-col gap-2 rounded ${PopoverBgStyles({ theme })}`}
                  >
                    <a
                      className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                      href="mailto:support@blockfin.com"
                    >
                      <span className="mx-[16px] text-sm">{t("supportService")}</span>
                    </a>

                    <a
                      className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                      href="mailto:listing@blockfin.com"
                    >
                      <span className="mx-[16px] text-sm">{t("listing")}</span>
                    </a>

                    <a
                      className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                      href={`mailto:bd${reflectLang[locale] || ""}@blockfin.com`}
                    >
                      <span className="mx-[16px] text-sm">{t("businessOpportunity")}</span>
                    </a>
                    <a
                      className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                      href={`mailto:legalrequest@blockfin.com`}
                    >
                      <span className="mx-[16px] text-sm">{t("lawEnforcementRequests")}</span>
                    </a>
                    <a
                      className={`py-[12px] ${LabelColor({ theme })} ${PopoverHoverStyle({ theme })}`}
                      href={`mailto:audit@blockfin.com`}
                    >
                      <span className="mx-[16px] text-sm">{t("audit")}</span>
                    </a>
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
